import Routes from "./routes/routes";
import { BrowserRouter as Router } from "react-router-dom";
import './App.css';

export default function App() {

  return (
    <>
    
    <Router>
      <Routes />
    </Router>

    </>
  );
}